export default __webpack_public_path__ + "static/media/Choubassi Jewelry.c30f307f.jpeg";